module.exports = __webpack_public_path__ + "static/media/wfh-cams.af9fd45d.xlsx";